<template>
	<div class="magdc">
		<div class="magdc_d1">
			<div class="magdcd1_d1">
				<h3>{{ detail.Title }}</h3>
				<!-- <span>作者：爱迪生、邓小平</span> -->
			</div>
			<div class="magdcd1_d2" v-html="detail.Content">
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				id:"",
				detail:""
			}
		},
		computed: {

		},
		watch: {

		},
		created: function() {
			if(typeof(this.$route.query.id) != "undefined"){
				this.id= this.$route.query.id
				this.GetNewsList()
				
			}
			
		},
		mounted: function() {
			
		},
		methods: {
			back(){
				this.$router.back();
			},
			GetNewsList(){
				var that = this;
				that.$post('GetNewsList', {
						"page": 0,
						NewsId:that.id
					})
					.then(function(res) {
						that.detail = res.data.ResultData[0]
					})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
.magdc{
	width: 100%;
	background-color: #f5f5f5;
	display: flex;
	flex-direction: column;
}

.magdc_d1{
	width: 1200px;
	min-height: 985px;
	background-color: #fff;
	margin: 28px auto;
	margin-top: 28px;
	display: flex;
	flex-direction: column;
}

.magdcd1_d1{
	width: 1106px;
	text-align: center;
	box-sizing: border-box;
	border-bottom:1px solid #eeeeee;
	margin: 0 auto;
	padding-bottom: 22px;
}

.magdcd1_d1 span{
	font-size: 14px;
	color: #333333;
}

.magdcd1_d2{
	width: 1106px;
	margin: 28px auto;
	line-height: 30px;
	font-size: 14px;
	color: #333333;
}

.magdcd1_d3{
	flex: 1;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	width: 1106px;
	margin: 0 auto;
}

.magdcd1d3_pad{
	width: 1106px;
	height: 105px;
	line-height: 105px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	border-top:1px solid #eeeeee;
}

.magdcd1d3_pad a{
	width: 144px;
	font-size: 16px;
	cursor:pointer;
}

.magdcd1d3_pad a:nth-child(2){
	color: #398e53;
}
</style>

<style lang="scss" scoped src="./mobile.scss" ></style>